import { combineReducers } from "@reduxjs/toolkit";
import gameEntity from "./entities/gameEntity";
import userEntity from "./entities/userEntity";
import resultTimeEntity from "./entities/resultTimeEntity";
import transactionEntity from "./entities/transactionEntity";
import resultEntity from "./entities/resultEntity";

export default combineReducers({
  gameReducer: gameEntity,
  userReducer: userEntity,
  resultTimeReducer: resultTimeEntity,
  transactionReducer: transactionEntity,
  resultReducer: resultEntity
});